export default function GoldDivider({ className = "" }) {
  return (
    <div className={`w-full ${className}`}>
      <div className="h-px bg-gradient-to-r from-transparent via-[#C6A75E]/30 to-transparent" />
    </div>
  );
}
